import apiClient from '@/services/AccountClient'
import clientRequestsClient from '@/services/ClientRequestsClient'
import { CLIENT_REQUEST_TYPES } from '@/models/ClientRequest'
import { HEADER_SKIP_AUTOEXTEND } from '@/services/ApiClient/ApiClient'

const fetchAll = (queryParams, silent, options) => clientRequestsClient.sendRequest(
  'GET',
  'api/v1/admin/requests',
  { ...queryParams, service: 'bilder-account' },
  silent != null
    ? { headers: { [HEADER_SKIP_AUTOEXTEND]: true }, ...options }
    : options
)

export default {
  create (profileId, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/client-requests?profileId=${profileId}`,
      data
    )
  },
  fetchAll (params, options) {
    const { silent, ...queryParams } = params
    return fetchAll(queryParams, silent, options)
  },
  fetchForexRequests (params, options) {
    const { silent, ...queryParams } = params
    return fetchAll({ ...queryParams, requestType: CLIENT_REQUEST_TYPES.CURRENCY_CONVERSION }, silent, options)
  },
  fetchTotalCountOfUnreadRequests (options) {
    return clientRequestsClient.sendRequest(
      'GET',
      `api/v1/admin/requests-count`,
      null,
      { headers: { [HEADER_SKIP_AUTOEXTEND]: true }, ...options }
    )
  },
  fetchCountOfUnreadForexRequests (options) {
    return clientRequestsClient.sendRequest(
      'GET',
      `api/v1/admin/requests-count?requestType=${CLIENT_REQUEST_TYPES.CURRENCY_CONVERSION}`,
      null,
      {
        headers: { [HEADER_SKIP_AUTOEXTEND]: true },
        params: { requestType: CLIENT_REQUEST_TYPES.CURRENCY_CONVERSION },
        ...options
      }
    )
  },
  assign ({ profileId, seq }, employeeId) {
    return clientRequestsClient.sendRequest(
      'PUT',
      `api/v1/admin/profiles/${profileId}/requests/${seq}/admin`,
      { employeeId }
    )
  },
  close ({ profileId, seq }, { status, reason }) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/client-requests/profiles/${profileId}/requests/${seq}/close`,
      { status, reason }
    )
  },
  unread ({ profileId, seq }) {
    return clientRequestsClient.sendRequest(
      'PUT',
      `api/v1/admin/profiles/${profileId}/requests/${seq}/unread`
    )
  },
  updateRates ({ profileId, seq, agreedRate }) {
    return clientRequestsClient.sendRequest(
      'POST',
      `api/v1/admin/profiles/${profileId}/requests/${seq}/update`,
      { agreedRate }
    )
  },
  createMessage ({ profileId, seq }, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/client-requests/profiles/${profileId}/requests/${seq}/messages`,
      data
    )
  }
}
